import gql from 'graphql-tag'

export const LIST_ACCOUNTS_QUERY = gql`
  query listAccounts($queryString: String!) {
    accounts: query(queryString: $queryString)
  }
`
